import htmlToText from './htmlToText'

export default function getLetters(value?: string | null): string[] {
  return (
    htmlToText(value)?.match(/\p{N}|\p{L}|\p{P}|\p{M}|\p{S}|\p{Z}|\p{C}/gu) ??
    []
  )
}
